// extracted by mini-css-extract-plugin
export var container = "_g1-0";
export var dotAnimation = "_g1-2";
export var dotsLoading = "_g1-1";